import { StyledCol, StyledSeparator, StyledTitle } from '@/shared/styles';
import { StyledAccordionContent } from '../AccessibilityIssues.styles';
import { processDescriptionText } from '../AccessibilityIssues.utils';
import { RecommendationContentProps } from './Recommendations.consts';

export const RecommendationContent: React.FC<RecommendationContentProps> = ({
  recommendations,
}: RecommendationContentProps) => {
  return (
    <StyledCol $gap={32}>
      {recommendations.map((issue, i) => (
        <StyledCol $gap={32} key={`issue${i}`}>
          <StyledSeparator $width="100%" className={i === 0 ? 'bold' : ''} />
          <StyledCol $gap={12}>
            <StyledTitle level={3}>{issue.title}</StyledTitle>
            <StyledAccordionContent>
              {processDescriptionText(issue.description)}
            </StyledAccordionContent>
          </StyledCol>
        </StyledCol>
      ))}
    </StyledCol>
  );
};
